module.exports = __webpack_public_path__ + "static/media/  (79).74807454.jpg";